export const verifyNumber = (value) => /^[0-9]+$/.test(value);

export const verifyDouble = (value) => {
    const numberRex = new RegExp("^(?:\\d{0,5}\\.\\d{1,5})$|^\\d{0,5}$");
    return !numberRex.test(value);
};

export const customVerifyDouble = (value) => {
    if (isNaN(parseFloat(value))) return false;
    if (value.split(".")[1]?.length > 5 || parseFloat(value) > 100) return false;
    return true;
};

export const customVerifyPhoneNumber = (value) => {
    if (isNaN(parseFloat(value))) return false;
    return parseFloat(value) > 0;
};

export const customVerifyDoubleWithMin = (value, min) => {
    if (isNaN(parseFloat(value))) return false;
    return value >= min;
};

export const verifyLength = (value, length) => value?.length >= length;

export const verifyEmpty = (value, length) => value.length >= length;

export const verifyEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

export const checkString = (input) => {
    if (input === null) return true;
    if (input?.trim().length < 1 || !isNaN(input)) return true;
    return false;
};

export const checkDate = (input) => {
    if (input === null) return true;
    if (input?.trim().length < 1 || !isNaN(input)) return true;
    const date = new Date(input);
    const now = new Date();
    if (date <= now) return true;
    return false;
};

export const checkNumber = (input) => {
    if (input === null) return true;
    if (input.length < 1 || isNaN(input)) return true;
    return false;
};

export const errorStateChecker = (identificateur, valeur, errorStateSetter, typeOfControl) => {
    if (typeOfControl === "string") {
        errorStateSetter(lastState => ({ ...lastState, [identificateur]: checkString(valeur) }));
    }
    if (typeOfControl === "alphanumeric") {
        const isInvalid = (() => {
            if (valeur === null || valeur === undefined) return true;
            const str = String(valeur).trim();
            if (str.length < 1) return true;
            return !/^[a-zA-Z0-9]+$/.test(str);
        })();
        errorStateSetter(lastState => ({ ...lastState, [identificateur]: isInvalid }));
    }
    if (typeOfControl === "number") {
        errorStateSetter(lastState => ({ ...lastState, [identificateur]: checkNumber(valeur) }));
    }
    if (typeOfControl === "date") {
        errorStateSetter(lastState => ({ ...lastState, [identificateur]: checkString(valeur) }));
    }
};

export const toutesLesValeursSontValides = (objet) => {
    for (let key in objet) {
        if (objet[key] !== false) return false;
    }
    return true;
};

export const getvalue = (event) => event.target.value;

export const getValue = (event) => event;

export const getIdentificateur = (event) => {
    if (event.target.id) return event.target.id;
    if (event.target.name) return event.target.name;
};

export const getidentificateur = (value, name) => name;

export const setValue = (valeur, identificateur, stateSetter, errorStateSetter, typeOfControl) => {
    stateSetter(lastState => ({ ...lastState, [identificateur]: valeur }));
    errorStateChecker(identificateur, valeur, errorStateSetter, typeOfControl);
};
